export const API = 'https://admin:fynb[frth79@rssa.vm.ru/api/';
export const NOTIFICATION_URL = 'https://rssa.vm.ru/feeds/#id=';
export const SOCKET_URL = 'https://admin:fynb[frth79@rssa.vm.ru/';
export const SENDER_ID = '568223367960';

export const SOURCES = [
    "TASS Главные новости дня",
    "TASS Новости культуры",
    "TASS Новости Москвы и Подмосковья",
    "TASS Новости: Криминал и ЧП",
    "MSKAgency",
    "РИА",
    "Официальный портал Мэра и Правительства Москвы",
    "РБК",
    "Инфо риан",
    "RIA",
];


export const SIDEBAR_ITEMS = [
    {
        "path": "/profile",
        "title": "Профиль",
        "className": "profile_link",
        "icon": '<use xlink:href="#icon-profile" width="26px" height="31px"></use>'
    },
    {
        "path": "/feeds",
        "title": "Лента",
        "className": "feed_link",
        "icon": '<use xlink:href="#icon-feed" width="29px" height="26px"></use>'
    },
    {
        "path": "/bookmarks",
        "title": "Избранное",
        "className": "bookmark_link",
        "icon": '<use xlink:href="#icon-star" width="26px" height="25px"></use>'
    },
    {
        "path": "/dark_mode",
        "trigger_dark": true,
        "title": "Ночная тема",
        "className": "dark_link",
        "icon": '<use xlink:href="#icon-darkmode" width="25px" height="26px"></use>'
    }
];



// WEBPACK FOOTER //
// ./src/config.js